import RecyclingIcon from '@mui/icons-material/Recycling';
import ProductRecycleList from './ProductRecycleList';
import ProductRecycleCreate from './ProductRecycleCreate';
import ProductRecycleEdit from './ProductRecycleEdit';

export default {
    list: ProductRecycleList,
    create: ProductRecycleCreate,
    edit: ProductRecycleEdit,
    icon: RecyclingIcon,
};
